import { buildApiUrl, buildHeaders, handleResponse } from '@/network/api-client';

export interface NotificationPreferences {
  enabled: boolean;
  roadAdvice: boolean;
  roadResults: boolean;
  biography: boolean;
  townArrival: boolean;
  questCompleted: boolean;
  playerThoughts: boolean;
}

function parsePreferences(value: unknown): NotificationPreferences {
  const keys = ['enabled', 'roadAdvice', 'roadResults', 'biography', 'townArrival', 'questCompleted', 'playerThoughts'] as const;
  if (!value || typeof value !== 'object' || keys.some(key => typeof (value as Record<string, unknown>)[key] !== 'boolean')) {
    throw new Error('Invalid notification preferences response');
  }
  return Object.fromEntries(keys.map(key => [key, (value as NotificationPreferences)[key]])) as unknown as NotificationPreferences;
}

export const notificationPreferencesApi = {
  async load(signal: AbortSignal): Promise<NotificationPreferences> {
    return parsePreferences(await handleResponse<unknown>(await fetch(buildApiUrl('/hero/notification-preferences'), {
      headers: buildHeaders(), cache: 'no-store', signal,
    })));
  },
  async save(preferences: NotificationPreferences, signal: AbortSignal): Promise<NotificationPreferences> {
    return parsePreferences(await handleResponse<unknown>(await fetch(buildApiUrl('/hero/notification-preferences'), {
      method: 'PUT', headers: buildHeaders(), body: JSON.stringify(preferences), signal,
    })));
  },
};
